module.exports = __webpack_public_path__ + "img/dollar-hover.1ec32b1d.svg";